import { Col, Form, Row, Spinner } from "react-bootstrap"

import NotificationEvent from "../../../api/Randoms/Notification/NotificationEvent"
import ToggleSwitch from "../../FormattedInputs/ToggleSwitch"

interface NotificationMethodsTabProps {
  loading?: boolean
  events?: Record<string, NotificationEvent>
  showTitle?: boolean
  disabled?: boolean
  onChange: (code: string, checked: boolean) => void
}

function NotificationEventsTab({
  loading = false,
  events = {},
  showTitle = false,
  disabled = false,
  onChange,
}: NotificationMethodsTabProps) {
  return (
    <>
      {showTitle && <h5>Reminders</h5>}
      {loading && <Spinner animation="border" variant="secondary" className="mb-1" />}
      {!loading &&
        Object.values(events || {})
          .filter((e) => e.DisplayOrder > 0)
          .map((event) => (
            <Form.Group as={Row} className="mb-1" key={event.Code}>
              <Form.Label column sm={6} className="d-flex align-items-center">
                {event.Description}
              </Form.Label>
              <Col className="d-flex align-items-center">
                <ToggleSwitch
                  on="Yes"
                  off="No"
                  className="mb-0"
                  checked={event.selected}
                  onCheck={(checked) => onChange(event.Code, checked)}
                  disabled={disabled}
                />
              </Col>
            </Form.Group>
          ))}
    </>
  )
}

export default NotificationEventsTab
